import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class CrudService {
    public url = environment.web_api_url_base;
    constructor(private http: HttpClient) { }

    getAll(params): Observable<any> {
        return this.http.get(this.url + 'corso.php', { params });
    }

    api_getLoginClientAPP(codiceCliente) {
        var formData: any = new FormData();
        formData.append("type", 'get_LoginAppClient');
        formData.append("codiceCliente", codiceCliente);
        return this.http.post(this.url + 'corso.php', formData);
    }

    api_modificaPassword(idCorsista, newPassword) {
        var formData: any = new FormData();
        formData.append("type", 'cambioPassword');
        formData.append("idCorsista", idCorsista);
        formData.append("newPassword", newPassword);
        return this.http.post(this.url + 'corso.php', formData);
    }

    api_modificaPasswordEmail(username, email) {
        var formData: any = new FormData();
        formData.append("type", 'cambioPasswordEmail');
        formData.append("username", username);
        formData.append("email", email);
        return this.http.post(this.url + 'corso.php', formData);
    }

    api_get_ElencoCorsi(pag, idCorsista, sottoCategoria, queryFind, idCorsistaLogin){
        var formData: any = new FormData();
        formData.append("type", 'get_ElencoCorsi');
        formData.append("nPag", pag);
        //idCorsista per i miei corsi
        formData.append("idCorsista", idCorsista);
        //idCorsista di DEFAULT, cioè se ha fatto il login, per la visualizzazione dei prezzi
        formData.append("idCorsistaDefault", idCorsistaLogin);
        formData.append("sottoCategoria", sottoCategoria);
        formData.append("queryFind", queryFind);
        return this.http.post(this.url + 'corso.php', formData);
    }

    api_get_ElencoCorsiInHome(idCorsista){
        var formData: any = new FormData();
        formData.append("type", 'get_ElencoCorsiInHome');
        formData.append("idCorsista", idCorsista);
        return this.http.post(this.url + 'corso.php', formData);
    }

    api_get_SettingsValue(settingName){
        var formData: any = new FormData();
        formData.append("type", 'get_SettingsValue');
        formData.append("settingName", settingName);
        return this.http.post(this.url + 'corso.php', formData);
    }

    api_report_kickLogout(payload: any){
        var formData: any = new FormData();
        formData.append("type", 'report_kickLogout');
        formData.append("id_corsista",  payload.id_corsista  || 0);
        formData.append("id_partner",   payload.id_partner   || 0);
        formData.append("id_azienda",   payload.id_azienda   || 0);
        formData.append("scope_kicked", payload.scope_kicked || '');
        formData.append("scope_id",     payload.scope_id     || 0);
        formData.append("kick_ts",      payload.kick_ts      || 0);
        formData.append("login_ts",     payload.login_ts     || 0);
        return this.http.post(this.url + 'corso.php', formData);
    }


    api_get_ElencoSottoCategorie(){
        var formData: any = new FormData();
        formData.append("type", 'get_ElencoSottoCategorie');
        return this.http.post(this.url + 'corso.php', formData);
    }

    api_get_ElencoSottoCategorieAll(){
        var formData: any = new FormData();
        formData.append("type", 'get_ElencoSottoCategorieAll');
        return this.http.post(this.url + 'corso.php', formData);
    }

    api_get_ElencoSottoCategorieWeb(){
        var formData: any = new FormData();
        formData.append("type", 'get_ElencoSottoCategorieWeb');
        return this.http.post(this.url + 'corso.php', formData);
    }

    api_get_ElencoSottoCategorieWeb_Secondary(){
        var formData: any = new FormData();
        formData.append("type", 'get_ElencoSottoCategorieWeb_Secondary');
        return this.http.post(this.url + 'corso.php', formData);
    }

    api_getDetailTempoConnessioneDay(arrayDetail) {
        var formData: any = new FormData();
        formData.append("type", 'getDetailTempoConnessioneDay');
        formData.append("idCorso", arrayDetail['idCorso']);
        formData.append("idCorsista", arrayDetail['idCorsista']);
        formData.append("data", arrayDetail['dataDay']);
        return this.http.post(this.url + 'corso.php', formData);
    }


    api_get_ElencoPropostaCorsi(){
        var formData: any = new FormData();
        formData.append("type", 'get_ElencoPropostaCorsi');
        return this.http.post(this.url + 'corso.php', formData);
    }

    api_get_ElencoCorsiPartner(idPartner){
        var formData: any = new FormData();
        formData.append("type", 'get_ElencoCorsiPartner');
        formData.append("idPartner", idPartner);
        return this.http.post(this.url + 'corso.php', formData);
    }

    api_get_PartnerQRCODE(qr_code){
        var formData: any = new FormData();
        formData.append("type", 'getDetailPartnerFromQRCODE');
        formData.append("qr_code", qr_code);
        return this.http.post(this.url + 'corso.php', formData);
    }

    api_registraPagamento(arrayDetail){
        var formData: any = new FormData();
        formData.append("type", 'registraPagamento');

        formData.append("idCorso", arrayDetail['idCorso']);
        formData.append("idCorsista", arrayDetail['idCorsista']);
        formData.append("idPartner", arrayDetail['idPartner']);

        formData.append("idTransiction", arrayDetail['idTransiction']);
        formData.append("metodo", arrayDetail['metodo']);
        formData.append("status", arrayDetail['status']);
        formData.append("payer_id", arrayDetail['payer_id']);
        formData.append("payer_nome", arrayDetail['payer_nome']);
        formData.append("payer_cognome", arrayDetail['payer_cognome']);
        formData.append("payer_email", arrayDetail['payer_email']);
        formData.append("purchase_id", arrayDetail['purchase_id']);
        formData.append("purchase_importo_valuta", arrayDetail['purchase_importo_valuta']);
        formData.append("purchase_importo", arrayDetail['purchase_importo']);
        formData.append("payment_id", arrayDetail['payment_id']);
        return this.http.post(this.url + 'corso.php', formData);
    }


    api_addCorsistaInAula(idCorsista, idPartner, idCorso){
        var formData: any = new FormData();
        formData.append("type", 'addInAulaCorsista');
        formData.append("idCorso", idCorso);
        formData.append("idPartner", idPartner);
        formData.append("idCorsista", idCorsista);
        return this.http.post(this.url + 'corso.php', formData);
    }

    api_canShowProgressPlayer(idCorsista, idCorso) {
        var formData: any = new FormData();
        formData.append("type", 'getSettingPlayerCorsista');
        formData.append("idCorso", idCorso);
        formData.append("idCorsista", idCorsista);
        return this.http.post(this.url + 'corso.php', formData);
    }

    api_getDetailCorsista(idCorsista){
        var formData: any = new FormData();
        formData.append("type", 'getDetailCorsista');
        formData.append("idCorsista", idCorsista);
        return this.http.post(this.url + 'corso.php', formData);
    }

    api_setTImeoutCorsista(idCorsista, idCorsoSvolgimento, isAutomaticoTime){
        var formData: any = new FormData();
        formData.append("type", 'setTImeoutCorsista');
        formData.append("idCorsista", idCorsista);
        formData.append("idCorsoSvolgimento", idCorsoSvolgimento);
        formData.append("isAutomaticoTime", isAutomaticoTime);
        return this.http.post(this.url + 'corso.php', formData);
    }

    api_getDetailUser(idUser){
        var formData: any = new FormData();
        formData.append("type", 'getDetailUser');
        formData.append("idUser", idUser);
        return this.http.post(this.url + 'corso.php', formData);
    }

    api_get_DetailCorso(id, idCorsista, isInLive, resetTimeFadEveryDays){
        var formData: any = new FormData();
        formData.append("type", 'get_DetailCorsoTag');
        formData.append("isInLive", isInLive);
        formData.append("id_corso", id);
        formData.append("id_corsista", idCorsista);
        formData.append("resetTimeFadEveryDays", resetTimeFadEveryDays);
        return this.http.post(this.url + 'corso.php', formData);
    }

    api_get_refreshModuloComplete(id, idCorsista, isInLive){
        var formData: any = new FormData();
        formData.append("type", 'get_refreshModuloComplete');
        formData.append("id_corso", id);
        formData.append("id_corsista", idCorsista);
        formData.append("isInLive", isInLive);
        return this.http.post(this.url + 'corso.php', formData);
    }

    api_get_DetailPartner(idPartner){
        var formData: any = new FormData();
        formData.append("type", 'getDetailPartner');
        formData.append("idPartner", idPartner);
        return this.http.post(this.url + 'corso.php', formData);
    }

    api_Login(username, password) {
        var formData: any = new FormData();
        formData.append("type", 'get_Login');
        formData.append("username", username);
        formData.append("password", password);
        return this.http.post(this.url + 'corso.php', formData);
    }

    salvaCheckTime(dateTimeInizio, dateTimeConfermaPresenza, isPresent, idCorsoSvolgimento, idCorsista, idCorso, timeCheck) {
        var formData: any = new FormData();
        formData.append("type", 'salvaCheckTime');
        formData.append("idCorsoSvolgimento", idCorsoSvolgimento);
        formData.append("idCorsista", idCorsista);
        formData.append("idCorso", idCorso);
        formData.append("timeCheck", timeCheck);
        formData.append("dateTimeInizio", dateTimeInizio);
        formData.append("dateTimeConfermaPresenza", dateTimeConfermaPresenza);
        formData.append("isPresent", isPresent);
        return this.http.post(this.url + 'corso.php', formData);
    }

    api_get_ElencoAulaCorso(idCorso, idCorsista) {
        var formData: any = new FormData();
        formData.append("type", 'get_ElencoAulaCorso');
        formData.append("id_corso", idCorso);
        formData.append("id_corsista", idCorsista);
        return this.http.post(this.url + 'corso.php', formData);
    }

    api_get_ElencoAulaCorsoTag(tag, idCorsista) {
        var formData: any = new FormData();
        formData.append("type", 'get_ElencoAulaCorsoTag');
        formData.append("tag", tag);
        formData.append("id_corsista", idCorsista);
        return this.http.post(this.url + 'corso.php', formData);
    }

    api_get_DetailQuiz(idCorso, idCorsista, idCorsoSvolgimento) {
        var formData: any = new FormData();
        formData.append("type", 'get_DetailQuiz');
        formData.append("id_corso", idCorso);
        formData.append("id_corsista", idCorsista);
        formData.append("id_corso_svolgimento", idCorsoSvolgimento);
        return this.http.post(this.url + 'corso.php', formData);
    }

    getLiveFromIdCorsoAndPartner(arrayDetail) {
        var formData: any = new FormData();
        formData.append("type", 'getLiveFromIdCorsoAndPartner');
        formData.append("idCorso", arrayDetail['idCorso']);
        formData.append("idCorsoSvolgimento", arrayDetail['idCorsoSvolgimento']);
        formData.append("idPartner", arrayDetail['idPartner']);
        return this.http.post(this.url + 'corso.php', formData);
    }

    api_getElencoSessioniEsameFrontEnd(idCorsista, idCorso) {
        var formData: any = new FormData();
        formData.append("type", 'getElencoSessioniEsameFrontEnd');
        formData.append("id_corsista", idCorsista);
        formData.append("id_corso", idCorso);
        return this.http.post(this.url + 'corso.php', formData);
    }

    api_getSessioneEsameCorsista(idCorsista, idCorso) {
        var formData: any = new FormData();
        formData.append("type", 'getSessioneEsameCorsista');
        formData.append("id_corsista", idCorsista);
        formData.append("id_corso", idCorso);
        return this.http.post(this.url + 'corso.php', formData);
    }

    api_getElencoEsamiForCorsoCorsista(arrayDetail) {
        var formData: any = new FormData();
        formData.append("type", 'get_ElencoEsamiForCorsoCorsista');
        formData.append("id_corso", arrayDetail['id_corso']);
        formData.append("id_corsista", arrayDetail['id_corsista']);
        formData.append("dataSessioneEsame", arrayDetail['dataSessioneEsame']);
        return this.http.post(this.url + 'corso.php', formData);
    }

    api_prenotaSessioneEsame(arrayDetail) {
        var formData: any = new FormData();
        formData.append("type", 'prenotaSessioneEsame');
        formData.append("id_corso", arrayDetail['id_corso']);
        formData.append("id_corsista", arrayDetail['id_corsista']);
        formData.append("idEsameBody", arrayDetail['idEsameBody']);
        return this.http.post(this.url + 'corso.php', formData);
    }

    api_deleteEsamePrenotato(arrayDetail) {
        var formData: any = new FormData();
        formData.append("type", 'deleteEsamePrenotato');
        formData.append("idEsameScelto", arrayDetail['idEsameScelto']);
        return this.http.post(this.url + 'corso.php', formData);
    }

    api_eliminaCorsistaSessioneEsame(arrayDetail) {
        var formData: any = new FormData();
        formData.append("type", 'eliminaCorsistaSessioneEsame');
        formData.append("idEsameCorsisti", arrayDetail['idEsameCorsisti']);
        return this.http.post(this.url + 'corso.php', formData);
    }

    api_verifica_quiz(arrayDetail) {
        var formData: any = new FormData();
        formData.append("type", 'get_verificaQuiz');
        formData.append("listaRisposte", JSON.stringify(arrayDetail));
        return this.http.post(this.url + 'corso.php', formData);
    }

    api_GeneraAttestato(details) {
        var formData: any = new FormData();
        formData.append("type", 'get_InfoForCertificate');
        formData.append("id_corso", details['id_corso']);
        formData.append("id_corsista", details['id_corsista']);
        formData.append("id_corso_svolgimento", details['id_corso_svolgimento']);
        return this.http.post(this.url + 'corso.php', formData);
    }

    set_entraInAulaCorsista(details) {
        var formData: any = new FormData();
        formData.append("type", 'set_entraInAulaCorsista');
        formData.append("idCorsista", details['idCorsista']);
        formData.append("id_corso_svolgimento", details['idCorsoSvolgimento']);
        formData.append("id_corso_header", details['idCorsoHeader']);
        formData.append("durata", details['durata']);
        formData.append("nome_aula", details['nome_aula']);
        formData.append("link_aula", details['link_aula']);
        formData.append("data_inizio", details['dataInizio']);
        formData.append("data_fine", details['dataFine']);
        return this.http.post(this.url + 'corso.php', formData);
    }

    set_entraInMeetEsame(details) {
        var formData: any = new FormData();
        formData.append("type", 'set_entraInMeetEsame');
        formData.append("idCorsista", details['idCorsista']);
        formData.append("idEsameBody", details['idEsameBody']);
        formData.append("tipologia", details['tipologia']);
        return this.http.post(this.url + 'corso.php', formData);
    }

    set_dateTimeInizioEsame(details) {
        var formData: any = new FormData();
        formData.append("type", 'set_dateTimeInizioEsame');
        formData.append("idCorsista", details['idCorsista']);
        formData.append("idEsameBody", details['idEsameBody']);
        return this.http.post(this.url + 'corso.php', formData);
    }

    sent_Email(nome, email, telefono, messaggio, sceltaCorso) {
        var formData: any = new FormData();
        formData.append("nome", nome);
        formData.append("email", email);
        formData.append("telefono", telefono);
        formData.append("messaggio", messaggio);
        formData.append("sceltaCorso", sceltaCorso);
        return this.http.post(this.url + 'email.php', formData);
    }

    sent_IscrizioneForPartner(details) {
        let nome=details['nome'];
        let cognome=details['cognome'];
        let sesso=details['sesso'];
        let indirizzo=details['indirizzo'];
        let cap=details['cap'];
        let citta=details['citta'];
        let provincia=details['provincia'];
        let luogoNascita=details['luogoNascita'];
        let dataNascita=details['dataNascita'];
        let email=details['email'];
        let cellulare=details['cellulare'];
        let idCorso=details['idCorso'];
        let fileAllegato=details['fileAllefato'];
        let idPartner=details['idPartner'];
        let cf=details['cf'];

        var formData: any = new FormData();
        formData.append("idPartner", idPartner);
        formData.append("nome", nome);
        formData.append("cognome", cognome);
        formData.append("sesso", sesso);
        formData.append("cf", cf);
        formData.append("indirizzo", indirizzo);
        formData.append("cap", cap);
        formData.append("citta", citta);
        formData.append("provincia", provincia);
        formData.append("luogoNascita", luogoNascita);
        formData.append("dataNascita", dataNascita);
        formData.append("email", email);
        formData.append("cellulare", cellulare);
        formData.append("idCorso", idCorso);
        formData.append("fileAllegato", fileAllegato);

        return this.http.post(this.url + 'email_iscirizioneCorsistaFromPartner.php', formData);
    }

    sent_confermaIscrizioneCorsista(details) {
        let nome=details['nome'];
        let cognome=details['cognome'];
        let nomeCorso=details['nomeCorso'];
        let cf=details['cf'];
        let email=details['email'];
        let idPartner=details['idPartner'];

        var formData: any = new FormData();
        formData.append("nome", nome);
        formData.append("cognome", cognome);
        formData.append("cf", cf);
        formData.append("nomeCorso", nomeCorso);
        formData.append("email", email);
        formData.append("idPartner", idPartner);

        return this.http.post(this.url + 'email_confermaIscirizioneCorsista.php', formData);
    }

    get_creaAccountCorsista(details) {
        let nome=details['nome'];
        let cognome=details['cognome'];
        let sesso=details['sesso'];
        let indirizzo=details['indirizzo'];
        let cap=details['cap'];
        let citta=details['citta'];
        let provincia=details['provincia'];
        let luogoNascita=details['luogoNascita'];
        let dataNascita=details['dataNascita'];
        let email=details['email'];
        let cellulare=details['cellulare'];
        let fileAllegato=details['fileAllefato'];
        let idPartner=details['idPartner'];
        let cf=details['cf'];

        var formData: any = new FormData();
        formData.append("type", 'get_creaAccountCorsista');
        formData.append("idPartner", idPartner);
        formData.append("nome", nome);
        formData.append("cognome", cognome);
        formData.append("sesso", sesso);
        formData.append("cf", cf);
        formData.append("indirizzo", indirizzo);
        formData.append("cap", cap);
        formData.append("citta", citta);
        formData.append("provincia", provincia);
        formData.append("luogoNascita", luogoNascita);
        formData.append("dataNascita", dataNascita);
        formData.append("email", email);
        formData.append("cellulare", cellulare);
        formData.append("fileAllegato", fileAllegato);

        return this.http.post(this.url + 'corso.php', formData);
    }

    getTimeVideoVisualizzato(idCorsista, idCorso, idPartner, idModuloBody, idModuloBodyParagrafo, isInLive) {
        var formData: any = new FormData();
        formData.append("type", 'getTimeVideoVisualizzato');
        formData.append("isInLive", isInLive);
        formData.append("idCorso", idCorso);
        formData.append("idCorsista", idCorsista);
        formData.append("idPartner", idPartner);
        formData.append("idModuloBody", idModuloBody);
        formData.append("idModuloBodyParagrafo", idModuloBodyParagrafo);
        return this.http.post(this.url + 'corso.php', formData);
    }

    getVideoToken(videoFile) {
        var formData: any = new FormData();
        formData.append("type", 'getVideoToken');
        formData.append("videoFile", videoFile);
        return this.http.post(this.url + 'corso.php', formData);
    }

    canShowBarraVideo(idCorsoSvolgimento) {
        var formData: any = new FormData();
        formData.append("type", 'canShowBarraVideo');
        formData.append("idCorsoSvolgimento", idCorsoSvolgimento);
        return this.http.post(this.url + 'corso.php', formData);

    }

    resetTimeFadEveryDays(idCorsoSvolgimento) {
        var formData: any = new FormData();
        formData.append("type", 'resetTimeFadEveryDays');
        formData.append("idCorsoSvolgimento", idCorsoSvolgimento);
        return this.http.post(this.url + 'corso.php', formData);

    }

    checkIfSessioneIsTerminata(idCorsoSvolgimento) {
        var formData: any = new FormData();
        formData.append("type", 'checkIfSessioneIsTerminata');
        formData.append("idCorsoSvolgimento", idCorsoSvolgimento);
        return this.http.post(this.url + 'corso.php', formData);
    }


    salveTempoTrascorsoVideo(details) {
        var formData: any = new FormData();
        formData.append("type", 'salveTempoTrascorsoVideo');
        formData.append("isInLive", details['isInLive']);
        formData.append("autoSave", details['autoSave']);
        formData.append("idCorso", details['idCorso']);
        formData.append("idCorsoSvolgimento", details['idCorsoSvolgimento']);
        formData.append("idCorsista", details['idCorsista']);
        formData.append("idPartner", details['idPartner']);
        formData.append("idModuloBody", details['idModuloBody']);
        formData.append("idModuloBodyParagrafo", details['idModuloBodyParagrafo']);
        formData.append("tempoTrascorso", details['tempoTrascorso']);
        formData.append("tempoTrascorsoInSecondi", details['tempoTrascorsoInSecondi']);
        formData.append("isPDF", details['isPDF']);
        return this.http.post(this.url + 'corso.php', formData);
    }

    apiVerificaAttestato(details) {
        var formData: any = new FormData();
        formData.append("type", 'verifica-attestato');
        formData.append("nome", details['nome']);
        formData.append("cognome", details['cognome']);
        formData.append("data_nascita", details['data_nascita']);
        formData.append("cf", details['cf']);
        return this.http.post(this.url + 'corso.php', formData);
    }

    api_updateTimeReportEsame(details) {
        var formData: any = new FormData();
        formData.append("type", 'updateTimeReportEsame');
        formData.append("idCorso", details['idCorso']);
        formData.append("idCorsista", details['idCorsista']);
        formData.append("idQuizHeader", details['idQuizHeader']);
        formData.append("time", details['time']);
        return this.http.post(this.url + 'corso.php', formData);

    }


    /*
    createProduct(data){
        return this.http.post(this.url + 'create.php', data);
    }

    updateProduct(data){
        return this.http.post(this.url + 'update.php', data);
    }

    deleteProduct(id){
        return this.http.get(this.url + 'delete.php?id=' + id);
    }
    */

    // --- Questionario di Gradimento (Customer Satisfaction) ---

    api_getGradimentoConfig(idCorso, idPartner, idCorsista){
        var formData: any = new FormData();
        formData.append("type", 'getGradimentoConfig');
        formData.append("id_corso", idCorso);
        formData.append("id_partner", idPartner);
        formData.append("id_corsista", idCorsista);
        return this.http.post(this.url + 'corso.php', formData);
    }

    api_salvaGradimento(idCorso, idPartner, idCorsista, qualitaDidattica, qualitaOrganizzativa, utilitaPercepita, aspettative, commento){
        var formData: any = new FormData();
        formData.append("type", 'salvaGradimento');
        formData.append("id_corso", idCorso);
        formData.append("id_partner", idPartner);
        formData.append("id_corsista", idCorsista);
        formData.append("qualita_didattica", qualitaDidattica);
        formData.append("qualita_organizzativa", qualitaOrganizzativa);
        formData.append("utilita_percepita", utilitaPercepita);
        formData.append("aspettative", aspettative);
        formData.append("commento", commento);
        return this.http.post(this.url + 'corso.php', formData);
    }

    // Salta questionario gradimento Accordo Stato-Regioni (registra solo compilazione)
    api_saltaGradimento(idCorso, idPartner, idCorsista){
        var formData: any = new FormData();
        formData.append("type", 'saltaGradimento');
        formData.append("id_corso", idCorso);
        formData.append("id_partner", idPartner);
        formData.append("id_corsista", idCorsista);
        return this.http.post(this.url + 'corso.php', formData);
    }

    // ECM — Salva gradimento ECM (6 aree AGENAS)
    api_salvaGradimentoEcm(idCorso, idPartner, idCorsista, rilevanza, qualitaEducativa, efficacia, organizzazione, sponsorizzazione, giudizioComplessivo, commento){
        var formData: any = new FormData();
        formData.append("type", 'salvaGradimentoEcm');
        formData.append("id_corso", idCorso);
        formData.append("id_partner", idPartner);
        formData.append("id_corsista", idCorsista);
        formData.append("rilevanza", rilevanza);
        formData.append("qualita_educativa", qualitaEducativa);
        formData.append("efficacia", efficacia);
        formData.append("organizzazione", organizzazione);
        formData.append("sponsorizzazione", sponsorizzazione);
        formData.append("giudizio_complessivo", giudizioComplessivo);
        formData.append("commento", commento);
        return this.http.post(this.url + 'corso.php', formData);
    }

    // ECM — Salta questionario gradimento (registra solo compilazione senza risposte)
    api_saltaGradimentoEcm(idCorso, idPartner, idCorsista){
        var formData: any = new FormData();
        formData.append("type", 'saltaGradimentoEcm');
        formData.append("id_corso", idCorso);
        formData.append("id_partner", idPartner);
        formData.append("id_corsista", idCorsista);
        return this.http.post(this.url + 'corso.php', formData);
    }

    // ECM — Domanda antifrode casuale
    api_getEcmAntifrodeQuestion(idCorso, idPartner) {
        var formData: any = new FormData();
        formData.append("type", 'getEcmAntifrodeQuestion');
        formData.append("details", JSON.stringify({idCorso: idCorso, idPartner: idPartner}));
        return this.http.post(this.url + 'corso.php', formData);
    }

    // ECM — Log risposta antifrode
    api_logEcmAntifrode(idCorsista, idCorso, idPartner, idDomanda, rispostaData, esito, minuteCorso) {
        var formData: any = new FormData();
        formData.append("type", 'logEcmAntifrode');
        formData.append("details", JSON.stringify({
            idCorsista: idCorsista, idCorso: idCorso, idPartner: idPartner,
            idDomanda: idDomanda, rispostaData: rispostaData, esito: esito, minuteCorso: minuteCorso
        }));
        return this.http.post(this.url + 'corso.php', formData);
    }

    // ECM — Registra tentativo test
    api_registraEcmTentativo(idCorsista, idCorso, idPartner, punteggio, corrette, totali, superato) {
        var formData: any = new FormData();
        formData.append("type", 'registraEcmTentativo');
        formData.append("details", JSON.stringify({
            idCorsista: idCorsista, idCorso: idCorso, idPartner: idPartner,
            punteggio: punteggio, corrette: corrette, totali: totali, superato: superato
        }));
        return this.http.post(this.url + 'corso.php', formData);
    }

    // ECM — Segna corso revisionato dopo fallimento
    api_ecmSetRevisionato(idCorsista, idCorso, idPartner) {
        var formData: any = new FormData();
        formData.append("type", 'ecmSetRevisionato');
        formData.append("details", JSON.stringify({idCorsista: idCorsista, idCorso: idCorso, idPartner: idPartner}));
        return this.http.post(this.url + 'corso.php', formData);
    }

    // ECM — Assegna crediti
    api_assegnaEcmCrediti(idCorsista, idCorso, idPartner) {
        var formData: any = new FormData();
        formData.append("type", 'assegnaEcmCrediti');
        formData.append("details", JSON.stringify({idCorsista: idCorsista, idCorso: idCorso, idPartner: idPartner}));
        return this.http.post(this.url + 'corso.php', formData);
    }

    // ECM — Salva progresso revisione video
    api_ecmSalvaProgressoRevisione(idCorsista, idCorso, idPartner, idModuloBodyParagrafo, tempoSecondi) {
        var formData: any = new FormData();
        formData.append("type", 'ecmSalvaProgressoRevisione');
        formData.append("details", JSON.stringify({idCorsista: idCorsista, idCorso: idCorso, idPartner: idPartner, idModuloBodyParagrafo: idModuloBodyParagrafo, tempoSecondi: tempoSecondi}));
        return this.http.post(this.url + 'corso.php', formData);
    }

    // ECM — Leggi progresso revisione video
    api_ecmGetProgressoRevisione(idCorsista, idCorso, idPartner, idModuloBodyParagrafo) {
        var formData: any = new FormData();
        formData.append("type", 'ecmGetProgressoRevisione');
        formData.append("details", JSON.stringify({idCorsista: idCorsista, idCorso: idCorso, idPartner: idPartner, idModuloBodyParagrafo: idModuloBodyParagrafo}));
        return this.http.post(this.url + 'corso.php', formData);
    }

    // ECM — Verifica se revisione completa
    api_ecmCheckRevisioneCompleta(idCorsista, idCorso, idPartner) {
        var formData: any = new FormData();
        formData.append("type", 'ecmCheckRevisioneCompleta');
        formData.append("details", JSON.stringify({idCorsista: idCorsista, idCorso: idCorso, idPartner: idPartner}));
        return this.http.post(this.url + 'corso.php', formData);
    }

    api_getSfidaMieClassifiche(idCorsista) {
        var formData: any = new FormData();
        formData.append("type", 'sfida_mie_classifiche');
        formData.append("details", JSON.stringify({idCorsista: idCorsista}));
        return this.http.post(this.url + 'corso.php', formData);
    }

    api_ecmGetProgressoRevisioneAll(idCorsista, idCorso, idPartner) {
        var formData: any = new FormData();
        formData.append("type", 'ecmGetProgressoRevisioneAll');
        formData.append("details", JSON.stringify({idCorsista: idCorsista, idCorso: idCorso, idPartner: idPartner}));
        return this.http.post(this.url + 'corso.php', formData);
    }

    api_getTelegramStatus(idCorsista) {
        var formData: any = new FormData();
        formData.append("type", 'getTelegramStatus');
        formData.append("idCorsista", idCorsista);
        return this.http.post(this.url + 'corso.php', formData);
    }

    api_disconnectTelegram(idCorsista) {
        var formData: any = new FormData();
        formData.append("type", 'disconnectTelegram');
        formData.append("idCorsista", idCorsista);
        return this.http.post(this.url + 'corso.php', formData);
    }
}
